import { Component, Host, h, Prop, State } from '@stencil/core';
// import moment from 'moment';
import { DateTime } from "luxon";
import '../loader-component/loader-component'
import '../header-component/header-component';
import { NewsitemComponent } from '../newsitem-component/newsitem-component';


/**
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/about-component.PNG)

#### Content Type
nypwebc_ct_announcements
 */

@Component({
  tag: 'announcements-all-component',
  styleUrl: 'announcements-all-component.css',
  // shadow: true,
  scoped: true
})
export class AnnouncementsallComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

   /**
  *Optional - To show/hide header. default is true
  */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
 *Optional - To show see All link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All Url
 */
  @Prop() seeallurl: string;

     /**
 *Optional - see All link Title
 */
 @Prop() seealltitle: string;

  
     /**
 *Optional - header background color
 */
 @Prop() headerbgcolor: string ="white"
 
 /**
 *Optional -header text color
 */
 @Prop() headertextcolor: string = "black"
 /**
 *Optional -header border bottom css
 */
 @Prop() headerborderbottom: string = "1px solid #CE2127"
 


  @State() items: [];
  @State() isLoading: boolean = true;

  @State() selectYearValue: string;
  @State() selectMonthValue: string;


  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    
    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    let currentYear = new Date().getFullYear()
    let filter = "(nypwebc_PostedDate ge datetime%27" + currentYear + "-01-01T00%3a00%3a00%27) and (nypwebc_PostedDate le datetime%27" + currentYear + "-12-31T00%3a00%3a00%27)"

    return fetch(siteUrl +  "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ShortDescription,nypwebc_ItemOrder,nypwebc_ImageUrl,nypwebc_ReadMore,nypwebc_PostedDate,nypwebc_Body&$filter=" + filter + "&$orderby=Modified desc", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results,
          this.isLoading = false
        this.selectYearValue = currentYear.toString(),
          this.selectMonthValue = '99'
      });


  }

  getYearOptions = () => {
    const yearsArray = []
    let currentYear = new Date().getFullYear()
    for (let i = 0; i < 5; i++) {
      let year = (currentYear - i).toString()
      yearsArray.push(<option value={year} selected={this.selectYearValue === year} >{year}</option>)
    }
    return yearsArray
  }

  getMonthOptions = () => {
    const monthsArray = []
    let months = [' ', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    let monthsnos = ['99', '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']
    // let monthsnos = [99, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
    for (let i = 0; i < 13; i++) {
      monthsArray.push(<option value={monthsnos[i]} selected={this.selectMonthValue === monthsnos[i]} >{months[i]}</option>)
    }
    return monthsArray
  }

  getContents = () => {
    const contentsArray = []
    this.items.forEach((item: any, index: any) => {

      console.log(index)
      // let postedDate = moment(item.nypwebc_PostedDate).format("MMMM DD YYYY, h:mm:ss A")
      let postedDate = DateTime.fromISO(item.nypwebc_PostedDate).toLocaleString(DateTime.DATETIME_MED)

      let newsItemUrl=""
      if ((window as any)._spPageContextInfo != null) {
        newsItemUrl = "/Pages/NewsItem.aspx"
      }
      else {
        // let domain = new URL(window.location.href)
        newsItemUrl =  "/SitePages/NewsItem.aspx"
      }

      

      let readMoreUrl = this.webpath + newsItemUrl + "?listname=" + this.listname + "&webpath=" + this.webpath + "&newsid=" + item.ID

      if (item.nypwebc_ReadMore) {
        readMoreUrl = item.nypwebc_ReadMore
      }

      contentsArray.push(
        <div>
          <a href={readMoreUrl} target="_blank" data-interception="off" rel="noopener noreferrer" id={item.ID}  >
            <div class="row">
              <div class="col-md-2 mx-auto d-block" >
                <img class="rounded mx-auto d-block img-fluid border-0" src={item.nypwebc_ImageUrl} />
              </div>
              <div class="col-md-10">
                <div style={{ fontSize: "16px", color: "#212529" }}>
                  <h4 style={{ fontSize: "20px", color: "#777777", fontWeight: "600" }}>    {item.Title}  </h4>
                  <p>{postedDate}</p>
                  <p> {item.nypwebc_ShortDescription}</p>
                </div>
              </div>
            </div>
          </a>
          <hr></hr>
        </div>
      )

    })
    if (contentsArray.length <=0)
    {
      contentsArray.push(<div> No entries for the specified period </div>);
    }
    return contentsArray
  }

  handleClick = () => {
    // this.getYearOptions()
    let actualMonth = parseInt(this.selectMonthValue) + 1
    let daysInMonth = new Date(parseInt(this.selectYearValue), parseInt(this.selectMonthValue) + 1, 0).getDate().toString()
    let filter = ""
    if (this.selectMonthValue === "99") {
      filter = "(nypwebc_PostedDate ge datetime%27" + this.selectYearValue + "-01-01T00%3a00%3a00%27) and (nypwebc_PostedDate le datetime%27" + this.selectYearValue + "-12-31T00%3a00%3a00%27)"
    }
    else {
      filter = "(nypwebc_PostedDate ge datetime%27" + this.selectYearValue + "-" + actualMonth + "-01T00%3a00%3a00%27) and (nypwebc_PostedDate le datetime%27" + this.selectYearValue + "-" + actualMonth + "-" + daysInMonth + "T12%3a00%3a00%27)"
    }

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin
    }

    return fetch(siteUrl + this.webpath + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ShortDescription,nypwebc_ItemOrder,nypwebc_ImageUrl,nypwebc_ReadMore,nypwebc_PostedDate,nypwebc_Body&$filter=" + filter + "&$orderby=Modified desc", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results,
          this.isLoading = false
      });

  }

  handleYearSelect(event) {
    console.log(event.target.value);
    this.selectYearValue = event.target.value;
    this.handleClick()
  }
  handleMonthSelect(event) {
    console.log(event.target.value);
    this.selectMonthValue = event.target.value;
    this.handleClick()
  }


  render() {

    let allNewsPage=""
    if ((window as any)._spPageContextInfo != null) {
      allNewsPage =  "/pages/allitems.aspx"
    }
    else {
      // let domain = new URL(window.location.href)
      allNewsPage = "/SitePages/allitems.aspx"
    }


    let allNewsUrl = this.webpath + allNewsPage + "?listname=" + this.listname + "&pagetitle=All " + this.sectiontitle + "&images=false"
    if (this.seeallurl) {
      allNewsUrl = this.seeallurl

    }

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        padding:"20px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        padding:"20px"
      }
    }


    return (

      this.isLoading ? <loader-component /> :
        this.header   && this.items.length > 0  ?
          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle= {this.seealltitle} seeallurl={allNewsUrl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
              <div class="row" style={{marginTop:"20px"}} >
                <div class="col-md-6" >
                  <p>Select Year </p>
                  <select onInput={(event) => this.handleYearSelect(event)} class="form-select"  aria-label="select year">
                    {this.getYearOptions()}
                  </select>
                </div>

                <div class="col-md-6" >
                <p>Select Month </p>
                  <select onInput={(event) => this.handleMonthSelect(event)} 
                   class="form-select" aria-label="select month"
                   
                    >
                    {this.getMonthOptions()}
                  </select>
                </div>
                {/* <div class="col-md-4" style={{ marginTop: "20px" }} >
                  <button class="btn btn-secondary" type="button" 
                 
                   onClick={this.handleClick}
                  > Search </button>
                </div> */}
                <div class="col-md-12" style={{ marginTop: "20px" }}>
                  {this.getContents()}</div>
                  </div>
              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style}>
              <div class="row" style={{marginTop:"20px"}} >
              <div class="col-md-6" >
              <p>Select Year </p>
                <select onInput={(event) => this.handleYearSelect(event)} class="form-select" aria-label="select year">
                  {this.getYearOptions()}
                </select>
              </div>
              <div class="col-md-6" >
              <p>Select Month </p>
                <select onInput={(event) => this.handleMonthSelect(event)} class="form-select" aria-label="select month">
                  {this.getMonthOptions()}
                </select>
              </div>
              {/* <div class="col-md-4" style={{ marginTop: "20px" }} >
                <button class="btn btn-secondary" type="button" onClick={this.handleClick}> Search </button>
              </div> */}
              <div class="col-md-12" style={{ marginTop: "20px" }}>
                {this.getContents()}</div>
                </div>
            </div>
          </div>
    );
  }

}
